<template>
  <div class="smart_button_text" v-bind="$attrs">
    <slot></slot>
  </div>
</template>
<style lang="less" scoped>
.smart_button_text {
  display: inline-block;
  margin-right: 10px;
  cursor: pointer;
  color: red;
}
</style>
